var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.availableChains),function(chain){return _c('span',{key:chain.value,staticClass:"navbar-item",on:{"click":function($event){return _setup.changeChain(chain.value)}}},[_c('p',{staticClass:"menu-item mr-2"},[_vm._v("\n      "+_vm._s(chain.text)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }